export enum NotificationMessageLevels {
  LEVEL_INFO = 'info',
  LEVEL_ERROR = 'error',
  LEVEL_SUCCESS = 'success',
  LEVEL_WARNING = 'warning',
}

export interface WebsocketNotification {
  _id: string;
  date: string;
  user: string;
  level: NotificationMessageLevels;
  title: string;
  body: string;
}

export interface WebsocketRoleUpdatedMessage {
  user: string[];
  scopes: string[];
}

export interface WebsocketDialogMessage {
  type: 'success' | 'error' | 'info';
  message: string;
}

export enum WebsocketEvent {
  Notification = 'notification',
  RoleUpdated = 'roleUpdated',
  Dialog = 'dialog',
  ForceLogout = 'forceLogout',
  UpdateCredentials = 'updateCredentials',
}
